import React from "react"
import Title from "./Title"
import { graphql, useStaticQuery, Link } from "gatsby"

const Jobs = () => {
  const data = useStaticQuery(graphql`
    {
      allJob {
        nodes {
          id
          company
          role
          date_start
          date_end
          responsibilities
        }
      }
    }
  `)
  const jobs = data.allJob.nodes

  const formatDate = (start, end) => `${start || ""} — ${end ? end : "Present"}`

  return (
    <section className="section jobs">
      <Title title="Experience" />
      <div className="timeline section-center">
        {jobs.map(job => (
          <article className="timeline-item" key={job.id}>
            <div className="timeline-meta">
              <span className="timeline-date">{formatDate(job.date_start, job.date_end)}</span>
            </div>
            <div className="timeline-body">
              <h3 className="timeline-role">{job.role}</h3>
              <p className="timeline-company">{job.company}</p>
              {job.responsibilities && job.responsibilities.length > 0 && (
                <ul className="timeline-points">
                  {job.responsibilities.map((text, i) => (
                    <li key={i}>{text}</li>
                  ))}
                </ul>
              )}
            </div>
          </article>
        ))}
      </div>
      <Link to="/about" className="btn center-btn">
        more info
      </Link>
    </section>
  )
}

export default Jobs
